import { createApiClient } from '@/infrastructure/api/client'
import { RequestRepository } from '@/infrastructure/repositories/request.repository'
import { RequestService } from '@/domain/services/request.service'

let cachedService: RequestService | null = null

/**
 * Композабл для сервиса заявок (requests).
 * Использует общий экземпляр API-клиента и сервиса.
 */
export function useRequestService(): RequestService {
  if (!cachedService) {
    const config = useRuntimeConfig()
    const apiClient = createApiClient({
      baseUrl: config.public.NUXT_APP_LANDING_API,
    })
    const requestRepository = new RequestRepository(apiClient)
    cachedService = new RequestService(requestRepository)
  }
  return cachedService
}
